import React from "react";

const PrivacyPolicy = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Kebijakan Privasi Aplikasi [Datt]</h1>
      {/* <p><strong>Tanggal Berlaku:</strong> [Tanggal Berlaku Kebijakan Privasi]</p> */}

      <div style={styles.section}>
        <h2>1. Informasi yang Kami Kumpulkan</h2>
        <p>
          Kami hanya mengumpulkan informasi yang diperlukan untuk menjalankan
          dan meningkatkan aplikasi kami. Jenis informasi yang kami kumpulkan
          meliputi:
        </p>
        <ul>
          <li>
            <strong>Informasi yang Anda Berikan Secara Langsung:</strong> Ketika
            Anda menggunakan aplikasi, kami mungkin meminta Anda memberikan
            informasi pribadi seperti nama, alamat email, atau informasi kontak
            lainnya.
          </li>
          <li>
            <strong>Akses Kamera:</strong> Aplikasi kami meminta izin untuk
            mengakses kamera perangkat Anda untuk tujuan [validasi dengan
            gambar]. Kami tidak mengumpulkan atau menyimpan foto atau video
            tanpa izin Anda.
          </li>
        </ul>
      </div>

      <div style={styles.section}>
        <h2>2. Bagaimana Kami Menggunakan Informasi Anda</h2>
        <p>Informasi yang kami kumpulkan digunakan untuk tujuan berikut:</p>
        <ul>
          <li>Menyediakan dan meningkatkan layanan aplikasi kami.</li>
          <li>
            Mengirimkan pembaruan atau pemberitahuan penting terkait aplikasi.
          </li>
          <li>
            Menganalisis penggunaan aplikasi untuk tujuan peningkatan kinerja
            dan fungsionalitas.
          </li>
        </ul>
      </div>

      <div style={styles.section}>
        <h2>3. Keamanan Data</h2>
        <p>
          Kami berkomitmen untuk menjaga keamanan informasi pribadi Anda dan
          menggunakan langkah-langkah yang sesuai untuk melindungi data dari
          akses yang tidak sah, perubahan, pengungkapan, atau penghancuran.
        </p>
      </div>

      <div style={styles.section}>
        <h2>4. Berbagi Informasi</h2>
        <p>
          Kami tidak membagikan informasi pribadi Anda kepada pihak ketiga,
          kecuali jika diwajibkan oleh hukum atau untuk memenuhi kewajiban hukum
          yang berlaku.
        </p>
      </div>

      <div style={styles.section}>
        <h2>5. Perubahan Kebijakan Privasi</h2>
        <p>
          Kami berhak untuk memperbarui atau mengubah kebijakan privasi ini dari
          waktu ke waktu. Setiap perubahan akan diumumkan di halaman ini dengan
          mencantumkan tanggal pembaruan. Kami menyarankan Anda untuk memeriksa
          kebijakan privasi ini secara berkala.
        </p>
      </div>

      <div style={styles.section}>
        <h2>6. Kontak Kami</h2>
        <p>
          Jika Anda memiliki pertanyaan atau kekhawatiran mengenai kebijakan
          privasi ini atau cara kami menangani data pribadi Anda, Anda dapat
          menghubungi kami di:
        </p>
        <ul>
          <li>Email: [krestech.developer@gmail.com]</li>
          <li>
            Alamat: [Jalan Dailybox No.1, RT.001/RW.002, Pondok Bahar, Karang
            Tengah, Tangerang City, Banten 15159]
          </li>
        </ul>
      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "800px",
    margin: "0 auto",
    padding: "20px",
    backgroundColor: "#fff",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
    marginTop: "20px",
  },
  title: {
    textAlign: "center" as "center", // Casting agar tipe sesuai
    color: "#333",
  },
  section: {
    marginBottom: "20px",
  },
};

export default PrivacyPolicy;
